import { EntityInput, isURLAbsolute, LinkProps } from "helpers/url";
import { UrlObject } from "url";

export function productHref(entity: EntityInput): LinkProps["href"] {
  const obj: Partial<UrlObject> = {
    pathname: "/product/[product]",
    query: {
      product: `${entity.alias}.html`,
    },
  };

  if (entity.url) {
    if (isURLAbsolute(entity.url)) {
      return entity.url;
    }

    if (entity.url.includes("p_")) {
      const segments = entity.url
        .replace(/\//g, "")
        .replace("p_", "")
        .split("?");
      const otherQueries = segments[1]
        ? Object.fromEntries(new URLSearchParams(segments[1]))
        : {};

      obj.query = {
        product: segments[0],
        ...otherQueries,
      };
    } else {
      return entity.url;
    }
  }

  return obj;
}

export function productAs(entity: EntityInput): LinkProps["as"] {
  if (entity.url) {
    return entity.url;
  }
  return `/p_${encodeURIComponent(entity.alias)}.html`;
}
